import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import { PFE_ICONS } from 'constants/icons';
import { schedulePropTypes } from 'constants/propTypes';

import ActionsDropdown from './ActionsDropdown';
import messages from './ScheduleDetailV2.messages';
import { useEmailActionItems } from './useActionItems';

const EmailActionsMenu = ({ schedule }) => {
  const intl = useIntl();
  const { frosted, items, visible } = useEmailActionItems(schedule);

  if (!visible) {
    return null;
  }

  return (
    <ActionsDropdown
      dataCypress="schedule-detail-v2-email-menu"
      frosted={frosted}
      icon={PFE_ICONS.envelopeOutline}
      items={items}
      label={intl.formatMessage(messages.emailMenuLabel)}
    />
  );
};

EmailActionsMenu.propTypes = {
  schedule: PropTypes.shape(schedulePropTypes),
};

export default EmailActionsMenu;
